import dynamic from 'next/dynamic';
import type { FC } from 'react';

export type BinderNoteTextEditorProps = {
  value?: string;
  onChange?: (e: string) => void;
  onUploadingChange?: (uploading: boolean) => void;
};

const ClientEditor = dynamic(() => import('./TextEditor.client'), {
  ssr: false,
  loading: () => <div>Loading...</div>,
});

const BinderNoteTextEditor: FC<BinderNoteTextEditorProps> = (props) => (
  <ClientEditor {...props} />
);

export default BinderNoteTextEditor;
